import {ReactElement} from "react-markdown/lib/react-markdown";

export default function MainFilter(props: { children: ReactElement[] }) {
	return (
		<div
			// place items horizonally centered
			className={`main-filter-container gap-x-[10px] justify- flex flex-wrap md:grid  gap-y-6 grid-cols-4 min-h-[157px] px-6 md:gap-x-3 py-10 bg-white items-end md:grid-cols-2 shadow-md lg:bg-white rounded-[20px] rounded-tl-none ${
				props.children.length > 4 ? "lg:grid-cols-6" : "lg:grid-cols-4"
			} 2xl:px-10`}
		>
			{props.children}
		</div>
	);
}
